const BASE = 'https://unofficialelections.com';

/**
 * Update <head> meta tags dynamically for SPA pages.
 * All params optional — only those provided are written.
 */
export function setMeta({
  title,
  description,
  keywords,
  canonical,
  ogTitle,
  ogDescription,
  ogImage,
  ogUrl,
  ogType = 'website',
  twitterCard = 'summary_large_image',
} = {}) {
  const full = (path) => (path?.startsWith('http') ? path : `${BASE}${path}`);

  // <title>
  if (title) document.title = title;

  // Helper: find or create a meta/link tag and set its content attribute
  const setTag = (selector, attr, value, tag = 'meta') => {
    if (!value) return;
    let el = document.querySelector(selector);
    if (!el) {
      el = document.createElement(tag);
      // parse name/property/rel from selector e.g. meta[name="description"]
      const nameMatch = selector.match(/\[name="([^"]+)"\]/);
      const propMatch = selector.match(/\[property="([^"]+)"\]/);
      const relMatch  = selector.match(/\[rel="([^"]+)"\]/);
      if (nameMatch) el.setAttribute('name', nameMatch[1]);
      if (propMatch) el.setAttribute('property', propMatch[1]);
      if (relMatch)  el.setAttribute('rel', relMatch[1]);
      document.head.appendChild(el);
    }
    el.setAttribute(attr, value);
  };

  // Primary
  setTag('meta[name="description"]',   'content', description);
  setTag('meta[name="keywords"]',      'content', keywords);
  setTag('link[rel="canonical"]',      'href',    canonical ? full(canonical) : null, 'link');

  // Open Graph
  const resolvedOgImage = ogImage ? full(ogImage) : null;
  setTag('meta[property="og:title"]',       'content', ogTitle || title);
  setTag('meta[property="og:description"]', 'content', ogDescription || description);
  setTag('meta[property="og:image"]',       'content', resolvedOgImage);
  setTag('meta[property="og:url"]',         'content', ogUrl ? full(ogUrl) : canonical ? full(canonical) : null);
  setTag('meta[property="og:type"]',        'content', ogType);

  // Twitter / X
  setTag('meta[name="twitter:card"]',        'content', twitterCard);
  setTag('meta[name="twitter:title"]',       'content', ogTitle || title);
  setTag('meta[name="twitter:description"]', 'content', ogDescription || description);
  setTag('meta[name="twitter:image"]',       'content', resolvedOgImage);
}

/**
 * Inject or replace a <script type="application/ld+json"> block.
 * id = unique data-id to avoid duplicates on navigation.
 */
export function setJsonLd(id, data) {
  const existing = document.querySelector(`script[data-meta-id="${id}"]`);
  if (existing) existing.remove();
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.setAttribute('data-meta-id', id);
  script.textContent = JSON.stringify(data, null, 2);
  document.head.appendChild(script);
}

/** Remove a JSON-LD block injected by setJsonLd */
export function removeJsonLd(id) {
  document.querySelector(`script[data-meta-id="${id}"]`)?.remove();
}
